<template>
    <div class="left-nav-sec users-left-nav" role="navigation" aria-labelledby="UserManagementHeading">
        <h1 class="admin-content-heading" id="UserManagementHeading">User Management</h1>
        <ul class="nav navbar-nav">
            <li class="nav-item">
                <Promised :pending-delay="null" :promise="adminUserManagementUsers" v-slot:combined="{ data: resolvedUrl }"><a class="nav-link icon icon-user" :class="$props.activeComponent == 'users' ? ['active'] : []" @click.prevent="changePage({ page: 'AdminUserManagementUsers' })" :href="resolvedUrl" aria-label="Users">Users</a></Promised>
            </li>
            <li class="nav-item">
                <Promised :pending-delay="null" :promise="adminUserManagementGroups" v-slot:combined="{ data: resolvedUrl }"><a class="nav-link icon icon-users" :class="$props.activeComponent == 'groups' ? ['active'] : []" @click.prevent="changePage({ page: 'AdminUserManagementGroups' })" :href="resolvedUrl" aria-label="Groups">Groups</a></Promised>
            </li>
        </ul>
    </div>
</template>
<script lang="ts">
import { defineComponent, computed, inject } from "vue";
import { Promised } from "@/lib/Promised";
import { useMainStore } from "@/mainStore";
import { changePageInjectKey } from "@/AppShell.3.vue.InjectKeys";
export default defineComponent({
    components: {
        Promised,
    },
    props: ["activeComponent"],
    setup() {
        const mainStore = useMainStore();
        const changePage = inject(changePageInjectKey)!;

        const adminUserManagementUsers = computed(() => mainStore.getUrl("adminUserManagementUsers"));
        const adminUserManagementGroups = computed(() => mainStore.getUrl("adminUserManagementGroups"));

        return {
            adminUserManagementUsers,
            adminUserManagementGroups,

            changePage,
        };
    },
});
</script>
